import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import Layout, {Caricamento, Titolo, Vuoto} from '../Layout';
import {Avvisi, Errore, Indirizzo, TabellaOrdini, dataOra, gestisciErrore, getCliente, getOrdini} from '../woo';

// Scheda di un cliente registrato con i suoi ordini.
export default function ClientePage() {
    const {id} = useParams();
    const [risultato, setRisultato] = useState(null); // {cliente, avvisi}
    const [ordini, setOrdini] = useState(null);       // {totale, ordini}
    const [errore, setErrore] = useState('');

    useEffect(() => {
        setRisultato(null);
        setOrdini(null);
        setErrore('');
        getCliente(id).then(setRisultato).catch(gestisciErrore(setErrore));
        getOrdini({customer_id: id}).then(setOrdini).catch(gestisciErrore(setErrore));
    }, [id]);

    const c = risultato?.cliente;
    const nome = c ? [c.first_name, c.last_name].filter(Boolean).join(' ') || c.username : `#${id}`;

    return (
        <Layout>
            <Titolo indietro>
                {nome}
                {c && <small className="text-secondary fw-normal fs-6 ms-2">cliente #{c.id}</small>}
            </Titolo>
            <Errore messaggio={errore}/>
            {!errore && !c && <Caricamento/>}
            {c && (
                <>
                    <Avvisi avvisi={risultato.avvisi}/>
                    <div className="row g-3 mb-3">
                        <div className="col-12 col-md-4">
                            <div className="card h-100">
                                <div className="card-body">
                                    <h6 className="card-title">Account</h6>
                                    <div><a href={`mailto:${c.email}`}>{c.email}</a></div>
                                    <div className="text-secondary">username <span className="font-monospace">{c.username}</span></div>
                                    <div className="text-secondary">ruolo {c.role}</div>
                                    <div className="mt-2 small text-secondary">
                                        Registrato il {dataOra(c.date_created)}<br/>
                                        Ultima modifica {dataOra(c.date_modified)}
                                    </div>
                                    {c.is_paying_customer && <span className="badge text-bg-success mt-2">Ha acquistato</span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4"><Indirizzo titolo="Fatturazione" indirizzo={c.billing}/></div>
                        <div className="col-12 col-md-4"><Indirizzo titolo="Spedizione" indirizzo={c.shipping}/></div>
                    </div>
                </>
            )}
            {(c || ordini) && (
                <div className="card">
                    <div className="card-body">
                        <h6 className="card-title">Ordini</h6>
                        {ordini === null && <Caricamento/>}
                        {ordini?.ordini?.length === 0 && <Vuoto>Nessun ordine.</Vuoto>}
                        {ordini?.ordini?.length > 0 && <TabellaOrdini ordini={ordini.ordini}/>}
                    </div>
                </div>
            )}
        </Layout>
    );
}
